import { ProductForm } from "@/components";

import { useAppSelector } from "@/store/hooks";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const AddProduct = () => {
  const { allVariantAttributes } = useAppSelector((state) => state.seller);
 

  return (
  
    <div className="container xl:mx-auto py-12 px-8 md:px-6 max-w-1xl md:max-w-[90rem] h-full ">
    <div className="group h-10 md:px-4 py-2 mb-6  ">
        <Link to="/seller" className=" text-sm font-medium ">
          <ArrowLeft className="group-hover:translate-x-[-5px] transition-transform duration-300 h-4 w-4 inline-block mr-2" />
          Back to Inventory
        </Link>
      </div>
      <ProductForm attributes={allVariantAttributes} />
    </div>
   
  );
};

export default AddProduct;
